// extracted by mini-css-extract-plugin
module.exports = {"priceTableContainer":"DiscountInfoSection_priceTableContainer__EWgHW","priceTable":"DiscountInfoSection_priceTable__NauX9"};